import { OptionType } from '@/components/AutoComplete';
import { TableColumns } from '@/components/Table';
import { BuySell } from '@/models/BuySell/enum';

import { col } from './utils';

export const ATTACH_TRADE_SUPPORT = 'ATTACH_TRADE_SUPPORT';
export const TRADES_FOR_APPROVAL = 'TRADES_FOR_APPROVAL';
export const TRADES_FOR_EXECUTION = 'TRADES_FOR_EXECUTION';
export const TRADES_PENDING_EXECUTION = 'TRADES_PENDING_EXECUTION';
export const TRADES_EXECUTED_MISMATCHED = 'TRADES_EXECUTED_MISMATCHED';
export const TRADES_EXECUTED = 'TRADES_EXECUTED';
export const TRADES_CANCELLED = 'TRADES_CANCELLED';
export const MODAL_CANCEL_TRADES_ID = 'MODAL_CANCEL_TRADES_ID';
export const MODAL_SEND_TRADES_ID = 'MODAL_SEND_TRADES_ID';
export const MODAL_CHECK_CURRENCY_ID = 'MODAL_CHECK_CURRENCY_ID';
export const MODAL_CHECK_CURRENCY_APPROVAL_ID =
  'MODAL_CHECK_CURRENCY_APPROVAL_ID';
export const MODAL_HIDE_TRADES_ID = 'MODAL_HIDE_TRADES_ID';
export const MODAL_TRADE_DOCUMENTS_ID = 'MODAL_TRADE_DOCUMENTS_ID';
export const MODAL_UPLOAD_VALIDATION_ID = 'MODAL_UPLOAD_VALIDATION_ID';
export const MODAL_UPLOAD_SUCCESS_ID = 'MODAL_UPLOAD_SUCCESS_ID';
export const MODAL_BULK_BANK_CRITERIA_ID = 'MODAL_BULK_BANK_CRITERIA_ID';
export const MODAL_ADD_MORE_RUN_DATE_ID = 'MODAL_ADD_MORE_RUN_DATE_ID';
export const MODAL_APPROVE_TRADES_ID = 'MODAL_APPROVE_TRADES_ID';
export const MODAL_CHANGE_STATUS_ID = 'MODAL_CHANGE_STATUS_ID';
export const MODAL_BLOTTER_RESULT_ID = 'MODAL_BLOTTER_RESULT_ID';

export enum TabLabels {
  Approval = 'Trades for Approval',
  Execution = 'Trades to be sent for Execution',
  Pending = 'Trades Pending Execution',
  Mismatched = 'Trades Executed Mismatched',
  Executed = 'Executed Trades',
  Cancelled = 'Cancelled Trades',
}

export const BUY_SELL_OPTIONS: OptionType[] = [
  { value: BuySell.Buy, label: 'Buy' },
  { value: BuySell.Sell, label: 'Sell' },
];

export const STATUS_OPTIONS: OptionType[] = [
  { value: 1, label: 'Submitted' },
  { value: 3, label: 'Client - Approved' },
  { value: 4, label: 'Sent for Execution' },
  { value: 6, label: 'Canceled' },
  { value: 5, label: 'Executed - Approved' },
  { value: 8, label: 'Ready-To-Execute' },
  { value: 10, label: 'Executed-Data-Mismatch' },
];

export const FLEX_UNIT_PX = 140;

export const NO_COUNTERPARTY_OPTION: OptionType = {
  value: '0',
  label: 'NO counterparty',
};

export const COLUMN_ID = 'id_row' as const;

export enum GroupingAction {
  Neutral = 'neutral',
  Group = 'group',
  UnGroup = 'ungroup',
}

export const GROUPING_LABELS: Record<GroupingAction, string> = {
  [GroupingAction.Group]: 'Group Trades',
  [GroupingAction.UnGroup]: 'UnGroup Trades',
  [GroupingAction.Neutral]: 'Group/UnGroup',
};

export const NET_GROSS_OPTIONS = [
  { value: true, label: 'Gross' },
  { value: false, label: 'Net' },
];
